<template>
	<div class="card">
		<div class="card-header">
			<router-link :to="memberRoute(request.user)">
				<ximg
					class="pixelated avatar"
					:src="avatarUrl(request)"
					:style="avatarStyle(request)"
					eager
					:ariaLabel="request.user.username + ' avatar'"
					role="img"
				/>
			</router-link>
			<div class="card-title">
				<router-link class="username secondary-link" :to="memberRoute(request.user)">
					{{ request.user.username }}
				</router-link>
				<span class="secondary">
					Lvl {{ request.user.rankLevel }} {{ request.user.avatar.class.title }}
				</span>
			</div>
			<template v-if="request.status !== friendStatus.RECEIVED">
				<a
					v-if="currentUser.id === user.id"
					class="unfriend"
					@click="removePopup = true;"
				>
					<ximg
						:src="convertToCdnUrl('/api/dynimg/icon/unfriend/fff')"
						eager
						ariaLabel="unfriend icon"
						role="img"
					/>
				</a>
				<modal v-model="removePopup" container-style="padding: 20px">
					<h3
						v-if="request.status === friendStatus.ACCEPTED"
						class="level-three-heading"
					>
						Ta bort <span class="semibold">{{ request.user.username }}</span> som vän.
					</h3>
					<h3
						v-else-if="request.status === friendStatus.SENT"
						class="level-three-heading"
					>
						Avbryt vänförfrågan till <span class="semibold">{{ request.user.username }}</span>.
					</h3>
					<hr />
					<p v-if="request.status === friendStatus.ACCEPTED">
						Är du säker på att du vill ta bort <span class="semibold">{{ request.user.username }}</span> som din vän?
					</p>
					<p v-else-if="request.status === friendStatus.SENT">
						Är du säker på att du vill avbryta din vänförfrågan till <span class="semibold">{{ request.user.username }}</span>?
					</p>
					<span
						v-if="request.status === friendStatus.ACCEPTED"
						class="btn btn-danger btn-sm mr-4"
						@click="remove()"
					>
						Ja ta bort!
					</span>
					<span
						v-else-if="request.status === friendStatus.SENT"
						class="btn btn-danger btn-sm mr-4"
						@click="remove()"
					>
						Ja avbryt!
					</span>
					<span class="btn btn-default btn-sm" @click="removePopup = false">Nej whoops, missclick.</span>
				</modal>
			</template>
		</div>
		<ximg
			class="card-badge"
			:src="badgeUrl"
			eager
			:ariaLabel="this.latestActivity && this.latestActivity.type ? this.latestActivity.type + ' badge' : 'badge'"
			role="img"
		/>
		<hr v-if="latestActivity || request.status !== friendStatus.ACCEPTED" />

		<div class="card-body" v-if="request.status !== friendStatus.ACCEPTED">

			<template v-if="request.status === friendStatus.RECEIVED">
				<span class="semibold">{{ request.user.username }}</span> vill lägga till dig som vän!
				<br />
				<span class="btn btn-success btn-sm mr-2" @click="accept()">Acceptera</span>
				<span class="btn btn-danger btn-sm" @click="deny()">Neka</span>
			</template>

			<template v-if="request.status === friendStatus.SENT">
				Du har skickat en vänförfrågan till <span class="semibold">{{ request.user.username }}</span>
			</template>

		</div>
		<div class="card-body" v-else-if="latestActivity">
			<span
				v-if="latestActivity.type !== 'friend' && latestActivity.type !== 'achievement'"
				class="small d-block"
			>
				{{ latestActivityDate }}:
			</span>

			<div v-if="latestActivity.type === 'friend'" class="showcase">
				<p>
					<span class="small d-block">{{ latestActivityDate }}:</span>
					<span class="semibold">{{ request.user.username }}</span> har blivit vän med
					<router-link class="italic" :to="memberRoute(latestActivity.user)">
						{{ latestActivity.user.username }}
					</router-link>!
				</p>
				<router-link :to="memberRoute(latestActivity.user)">
					<ximg
						class="pixelated avatar"
						:src="avatarUrl(latestActivity)"
						:style="avatarStyle(latestActivity)"
						eager
						:ariaLabel="latestActivity.user.username + ' avatar'"
						role="img"
					/>
				</router-link>
			</div>

			<template v-if="latestActivity.type === 'review_vote'">
				<span class="semibold">{{ request.user.username }}</span> har betygsatt en
				<product-link :product="latestActivity.data.product">review/hype</product-link>!
				<review :review="latestActivity.data" compact />
			</template>

			<template v-if="latestActivity.type === 'comment_vote'">
				<span class="semibold">{{ request.user.username }}</span> har betygsatt en
				<product-link :product="latestActivity.data.product">fråga/svar</product-link>!
				<question :question="latestActivity.data" compact />
			</template>

			<template v-if="latestActivity.type === 'comment'">
				<span class="semibold">{{ request.user.username }}</span> har lämnat en fråga/svar på en
				<product-link :product="latestActivity.data.product">produkt</product-link>!
				<question :question="latestActivity.data" compact />
			</template>

			<template v-if="latestActivity.type === 'review'">
				<span class="semibold">{{ request.user.username }}</span> har lämnat en review/hype på en
				<product-link :product="latestActivity.data.product">produkt</product-link>!
				<review :review="latestActivity.data" compact />
			</template>

			<div
				v-if="latestActivity.type === 'achievement'"
				class="showcase clickable"
				@click="cheevoPopup = true"
			>
				<p>
					<span class="small d-block">{{ latestActivityDate }}:</span>
					<span class="semibold">{{ request.user.username }}</span> har låst upp achievementet <span class="italic">{{ latestActivity.data.name }}</span> (+{{ latestActivity.data.experiencePoints }} XP)!
				</p>
				<ximg
					class="clickable"
					:src="convertToAchievementUrl(latestActivity.data.imageName, 64, 64)"
					:fallback="convertToAchievementUrl('404', 64, 64)"
					eager
					:ariaLabel="latestActivity.data.name + ' achievement image'"
					role="img"
				/>
				<modal v-model="cheevoPopup">
					<achievement-modal :achievement="latestActivity.data"/>
				</modal>
			</div>

		</div>
	</div>
</template>

<script>
import alert from 'alert';
import { mapState } from 'vuex';
import memberUtils from 'utils/member';
import { convertToCdnUrl, convertToAchievementUrl, memberRoute } from 'utils';
import { friendStatus } from 'staticData';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import svLocale from 'date-fns/locale/sv';
import { t } from 'datastore/i18n';

export default {
	props: ['user', 'request'],
	data () {
		return {
			friendStatus,
			removePopup: false,
			cheevoPopup: false,
		};
	},
	methods: {
		convertToCdnUrl,
		convertToAchievementUrl,
		tm: t.prefix('MEMBER'),
		avatarStyle (request) {
			return memberUtils.avatarStyle(request);
		},
		avatarUrl (request) {
			return memberUtils.avatarUrl(request);
		},
		remove() {
			this.$emit('remove', this.request);
			this.removePopup = false;
		},
		accept () {
			waja.post('friend-request/'+this.request.id+'/accept')
				.on('success', res => {
					alert('Du är nu vän med ' + res.data.friend.username);
					this.$emit('update');
				}).go();
		},
		deny () {
			waja.post('friend-request/'+this.request.id+'/deny')
				.on('success', res => {
					alert('Vänförfrågan nekad.');
					this.$emit('update');
				}).go();
		},
		memberRoute (member) {
			return this.$router.route(memberRoute(member, 'member.achievements', 'ACHIEVEMENTS'));
		},
	},
	computed: {
		badgeUrl () {
			let type = 'vanner';
			switch (this.latestActivity && this.latestActivity.type) {
				case 'review_vote':
				case 'comment_vote':
					type = 'upvote';
					break;
				case 'review':
					type = 'review';
					break;
				case 'comment':
					type = 'answer';
					break;
				case 'achievement':
					type = 'achievement';
					break;
			}
			return `/img/icons/feed/feed_${type}.svg`;
		},
		latestActivity () {
			return this.request.latestActivity;
		},
		latestActivityDate () {
			const string = distanceInWordsToNow(this.latestActivity.datetime, {
				locale: svLocale,
				addSuffix: true,
				onlyNumeric: true,
			});
			return string;
		},
		...mapState({
			currentUser: state => state.user,
		}),
	},
};
</script>
